module.exports = "/images/measure-marking-first-point.svg?87580509b58c44d01433fecf2e576ba1";